import {MutationTree} from 'vuex';
import {RootState} from '@/store/index';
import {SET_GLOBAL_ERROR} from '@/types/store.types';
import {AxiosError} from 'axios';

export const mutations: MutationTree<RootState> = {

  [SET_GLOBAL_ERROR]: (state, globalError: AxiosError) => {
    state.globalError = globalError;
  }

};
